import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {languages, logo_image} from "../data/data";
import {useState} from "react";
import HamburgerMenu from "../components/HamburgerMenu";
import HamburgerIcon from "../components/common/HamburgerIcon";
import ArrowDown from "../components/common/ArrowDown";
import ProductMenu from "../components/ProductMenu";
import ic_phone from "../assets/icon/ic_phone_white.svg";
import ContactDialog from "../components/ContactDialog";

function Navigation() {
    const {i18n, t} = useTranslation();

    const selectedLanguage = languages.find(language => language.key === i18n.language);

    const [openHamburgerMenu, setOpenHamburgerMenu] = useState(false);
    const [openProductMenu, setOpenProductMenu] = useState(false);
    const [openLanguageMenu, setOpenLanguageMenu] = useState(false);
    const [open, setOpen] = useState(false);

    const toggleHamburgerMenu = () => {
        setOpenHamburgerMenu(!openHamburgerMenu);
    }

    const toggleProductMenu = () => {
        setOpenLanguageMenu(false);
        setOpenProductMenu(!openProductMenu);
    }

    const closeProductMenu = () => {
        setOpenProductMenu(false);
        navigateToTop();
    }

    const toggleLanguageMenu = (_) => {
        setOpenProductMenu(false);
        setOpenLanguageMenu(!openLanguageMenu);
    }

    const onLanguageChanged = async (key) => {
        setOpenLanguageMenu(false);
        navigateToTop();
        await i18n.changeLanguage(key);
    };

    const navigateToTop = () => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

    return (
        <div id="stickyHeader"
             className="flex justify-center w-full sticky top-0 z-[99999] bg-white shadow-lg border-b-[5px] border-secondary">
            <header className="container flex justify-between h-24 px-4 lg:max-w-80 py-4">
                <NavLink to="/" onClick={closeProductMenu}>
                  <img className="cursor-pointer" src={logo_image[t('logo')]} alt="Logo"/>
                </NavLink>
                <section className={`flex justify-center items-center gap-4 md:hidden`}>
                    <div className={`${openHamburgerMenu ? "hidden" : "visible"} space-y-2`}
                         onClick={toggleHamburgerMenu}>
                        <HamburgerIcon/>
                    </div>
                    {openHamburgerMenu && <HamburgerMenu toggleMenu={toggleHamburgerMenu}/>}
                </section>
                <div className="navigation items-end gap-4 lg:gap-6 hidden md:flex">
                    <NavLink to="/" onClick={closeProductMenu}
                             className={({isActive}) => (isActive ? 'active' : 'inactive')}>
                        {t('navigation_menu_home')}
                    </NavLink>
                    <NavLink to="/product" className={`flex flex-row text-base py-3 text-center items-center cursor-pointer`}
                             onClick={toggleProductMenu}>
                        {t('navigation_menu_product')}
                        <ArrowDown className="w-2.5 h-2.5 ms-3"/>
                        {openProductMenu && <ProductMenu onMouseLeave={() => setOpenProductMenu(false)}/>}
                    </NavLink>
                    <NavLink to="/about" onClick={closeProductMenu}
                             className={({isActive}) => (isActive ? 'active' : 'inactive')}>
                        {t('navigation_menu_about')}
                    </NavLink>
                    <NavLink to="/contact" onClick={closeProductMenu}
                             className={({isActive}) => (isActive ? 'active' : 'inactive')}>
                        {t('navigation_menu_contact')}
                    </NavLink>
                    <button onClick={toggleLanguageMenu}
                            className="flex flex-row text-base py-3 text-center items-center"
                            type="button">
                        {LanguageLabel(selectedLanguage)}
                        <ArrowDown className="w-2.5 h-2.5 ms-3"/>

                        {openLanguageMenu &&
                            <LanguageMenu selectedLanguage={selectedLanguage} onLanguageChanged={onLanguageChanged}/>}
                    </button>
                    <button onClick={() => setOpen(true)}
                            className="bg-primary text-white text-base font-bold flex flex-row items-center px-3 py-1 mb-2">
                        <img src={ic_phone} alt="Phone Icon" className="h-4 w-4 mr-1"/>
                        {t("navigation_menu_contact_sale")}
                    </button>
                </div>
            </header>
            <ContactDialog open={open} onClose={() => setOpen(false)}/>
        </div>
    );
}

export default Navigation;

const LanguageMenu = (props) => {
    return (
        <div className="absolute top-20 z-10 bg-white rounded-lg shadow dark:bg-gray-700">
            <div className="flex flex-col items-stretch">
                {languages.map((language, index) => {
                    return LanguageMenuItem(language, index,
                        props.selectedLanguage.key === language.key,
                        props.onLanguageChanged)
                })}
            </div>
        </div>
    )
}

const LanguageMenuItem = (language, index, isSelected, onLanguageChanged) => {
    return (
        <button onClick={() => onLanguageChanged(language.key)}
                key={language.key}
                role="menuitem"
                className={`${isSelected ? "bg-secondary-light" : ""} 
                        flex flex-row items-center px-6 py-2 text-base
                        ${index % 2 === 0 ? 'rounded-t' : 'rounded-b'}`}>
            {LanguageLabel(language)}
        </button>
    )
}

const LanguageLabel = (language) => {
    return (
        <>
            <img src={language.image} className="w-4 aspect-square mr-2"
                 alt={`Flag image: ${language.key}`}/>
            <span>{language.name}</span>
        </>
    )
}
